import { BaseClient } from '../client';
import { IndicacaoApiResponse, IndicacaoLink } from './indicacao.types';

export const postIndicacaoLink = async (origin: string) => {
	const response = await BaseClient.post<IndicacaoApiResponse<IndicacaoLink>>(
		'v2/Indicacao/Link',
		{ origin }
	);
	return response.data;
};
